import { Box, Button, Paper, Tooltip, Typography } from "@mui/material";
import { AddCircleOutline, Event } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Booking } from "../../Types/UnitFeatureTypes";
import BuildBookingsTable from "../BuildTables/BuildBookingsTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchBooking, fetchBookingCount } from "../../Redux/selectors";
import { Actions, RootState } from "../../Redux/Reducer/rootReducer";
import { FIXED_PAGE_ROWS } from "../../Utils/Constants";
import LoadingOverlay from "../CommonComponents/LoadingOverlay";
import SortComponent from "../CommonComponents/SortComponent";
import PageNavigation from "../CommonComponents/PageNavigation";
import ViewTableHeader from "../CommonComponents/ViewTableHeader";

const ViewBookingsTable: React.FC = () => {

    const navigate = useNavigate();
    const [sortDirection, setSortDirection] = useState<boolean>(false);
    const [sortColumn, setSortColumn] = useState<string>('created_on');
    const allBookings = useSelector(fetchBooking) as Booking[];
    const allBookingsCount = useSelector(fetchBookingCount) as string;
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [item, setItem] = useState<Booking[]>([]);
    const isLoading = useSelector((state: RootState) => state.fetchBooking.request.loading);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(Actions.fetchBooking.bookingActions.request({offset: (currentPage)*FIXED_PAGE_ROWS, sortColumn, sortDirection: sortDirection ? 'asc' : 'desc'}));
    },[currentPage, allBookingsCount, sortDirection, sortColumn]);

    useEffect(() => {
        setItem(allBookings);
    }, [allBookings]);

    useEffect(() => {
        const totalRequest = Number(allBookingsCount);
        const pages = Math.ceil(totalRequest/FIXED_PAGE_ROWS);
        setTotalPages(pages);
    }, [allBookingsCount]);

    const handleAddBooking = (event: React.MouseEvent<HTMLButtonElement>) => {
        navigate('/createBooking');
    }

    return (
        <>
        <LoadingOverlay isLoading={isLoading} />
        <Paper elevation={5} sx={{mb: 2, padding: 3, borderRadius: 3}}>
            <ViewTableHeader
                title="Bookings"
                icon={Event}
                handleAdd={handleAddBooking}
                addText="Add Booking"
                sortColumn={sortColumn}
                setSortColumn={setSortColumn}
                sortDirection={sortDirection}
                setSortDirection={setSortDirection}
                sortValues={[
                    { value: 'amenity_title', label: 'Amenity Name'},
                    { value: 'created_on', label: 'Create Date'},
                    { value: 'booking_date', label: 'Booking Date'},
                    { value: 'user', label: 'User'},
                    { value: 'unit', label: 'Unit'},
                    { value: 'status', label: 'Status'},
                ]}
            />
            <BuildBookingsTable item={item} />
            <PageNavigation
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
            />
        </Paper>
        </>
    )
}

export default ViewBookingsTable;